export default __webpack_public_path__ + "static/media/xperimenta.6c5c3822.png";